import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private _isLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private _gridLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private _unitsLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private _isConverting$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private _isNextDisabled$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public get isConverting$(): Observable<boolean> {
    return this._isConverting$.asObservable();
  }

  public get isNextDisabled$(): Observable<boolean> {
    return this._isNextDisabled$.asObservable();
  }

  public get isloading$(): Observable<boolean> {
    return this._isLoading$.asObservable();
  }

  public get gridloading$(): Observable<boolean> {
    return this._gridLoading$.asObservable();
  }

  public get unitsLoading$(): Observable<boolean> {
    return this._unitsLoading$.asObservable();
  }

  public setLoading(isLoading: boolean): void {
    this._isLoading$.next(isLoading);
  }
  public setConverting(isConverting: boolean): void {
    this._isConverting$.next(isConverting);
  }
  public setNextDisabled(disable: boolean): void {
    this._isNextDisabled$.next(disable);
  }

  public setUnitsLoading(isLoading: boolean): void {
    this._unitsLoading$.next(isLoading);
  }

  public setGridLoading(isLoading: boolean): void {
    this._gridLoading$.next(isLoading);
  }
}
